import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

import type { AvpFilterExpressionData } from './avp-filter-expression-common';

/**
 * Data payload for rendering a newly created AVP filter expression.
 */
export type AvpFilterExpressionCreateData = AvpFilterExpressionData & {
	/**
	 * The identifiers of the created filter expressions.
	 */
	expressionIds?: string[];
};

/**
 * Properties for the AVP filter expression creation command.
 *
 * @extends CommandProperties
 */
export interface AvpFilterExpressionCreateCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the filter expression creation request.
	 */
	key: string;
	/**
	 * The data payload containing the updated filter expression tree.
	 */
	data: AvpFilterExpressionCreateData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}

/**
 * A command sent by a bridge API client to render a newly created AVP filter expression.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to render the updated AVP filter expression tree after creation.
 */
export const AvpFilterExpressionCreateCommand: CommandConstructor<
	AvpFilterExpressionCreateCommandProperties,
	SerializableValue
> = createCommand<AvpFilterExpressionCreateCommandProperties>(
	'avp-filter-expression-create-command',
);
